import React, { Component } from 'react';
import pic2 from '../assets/images/Adel.jpg';

export default class Second extends Component {
    render() {
        const scrolling = () => {
            document.querySelector('#third').scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        };
        return (
            <section id="second" className="panel spotlight right">
                <div className="content right span-7-5">
                    <div className="medium">
                        <h1 className="major">About me</h1>
                        <blockquote>
                            “Change is inevitable. Growth is optional.”
                            <br />
                            <span>— John Maxwell</span>
                        </blockquote>
                        <p className="justifying">
                            This quote has resonated with me since I made the career switch from Physiotherapist to
                            Software Developer.
                            <br />
                            In late 2019, after a period of self-study, I joined a coding bootcamp in Amsterdam, which
                            confirmed my interest in coding and set me on a new professional path.
                            <br />
                            I'm now working as a Front-end Developer at IMAGIN.studio, continuing to build on the skills
                            I've developed over the past few years. I'm still just as curious and motivated to grow in
                            this field as I was when I started.
                        </p>
                    </div>

                    <button className="arrow" onClick={scrolling}>
                        <i className="arrow__icon fas fa-chevron-circle-right"></i>
                    </button>
                </div>
                <div className="image filtered tinted">
                    <img src={pic2} alt="Adel" id="adel-pic" />
                </div>
            </section>
        );
    }
}
